import Configurations from "Pages/Admin/Configurations";
import Dashboard from "Pages/Admin/Dashboard";
import NotificationCenter from "Pages/Admin/NotificationCenter";
import CreateNotificationType from "Pages/Admin/Notifications/CreateNotificationType";
import CreateNotification from "Pages/Admin/Notifications/CreateNotifications";
import ListNotifications from "Pages/Admin/Notifications/ListNotifications";
import ManageNotification from "Pages/Admin/Notifications/Notification";
import CreateParticipant from "Pages/Admin/Participants/CreateUser";
import DetailParticipant from "Pages/Admin/Participants/DetailParticipant";
import ListParticipants from "Pages/Admin/Participants/ListUsers";
import UpdateParticipantUser from "Pages/Admin/Participants/UpdateUser";
import PendingApprovals from "Pages/Admin/PendingApprovals";
import CreateProductions from "Pages/Admin/Productions/CreateProductions";
import ListProductions from "Pages/Admin/Productions/ListProductions";
import UpdateProductions from "Pages/Admin/Productions/UpdateProductions";
import ListProjects from "Pages/Admin/Projects/ListProjects";
import UpdateProjects from "Pages/Admin/Projects/UpdateProjects";
import CreateSeletiva from "Pages/Admin/Seletivas/CreateSeletiva";
import ListSeletivas from "Pages/Admin/Seletivas/ListSeletivas";
import UpdateSeletiva from "Pages/Admin/Seletivas/UpdateSeletiva";
import CreateSponsor from "Pages/Admin/Sponsors/CreateUser";
import DetailSponsor from "Pages/Admin/Sponsors/DetailSponsor";
import ListSponsors from "Pages/Admin/Sponsors/ListUsers";
import UpdateSponsorUser from "Pages/Admin/Sponsors/UpdateUser";
import CreateUser from "Pages/Admin/Users/CreateUser";
import ListUsers from "Pages/Admin/Users/ListUsers";
import UpdateUser from "Pages/Admin/Users/UpdateUser";

const AdminRoutes = {
  Dashboard: {
    icon: "GridAlt",
    name: "Dashboard",
    path: "/admin/dashboard",
    element: Dashboard,
  },
  ListUsers: {
    icon: "User",
    name: "Listar Usuários",
    path: "/admin/users/list",
    element: ListUsers,
  },
  CreateUsers: {
    icon: "User",
    name: "Criar Usuário",
    path: "/admin/users/create",
    element: CreateUser,
  },
  UpdateUsers: {
    icon: "User",
    name: "Atualizar Usuário",
    path: "/admin/users/update/:id",
    element: UpdateUser,
    parent: "ListUsers",
  },
  ListSponsors: {
    icon: "User",
    name: "Listar Patrocinadores",
    path: "/admin/sponsors/list",
    element: ListSponsors,
  },
  CreateSponsor: {
    icon: "User",
    name: "Criar Patrocinador",
    path: "/admin/sponsors/create",
    element: CreateSponsor,
  },
  DetailSponsor: {
    icon: "User",
    name: "Detalhe do Patrocinador",
    path: "/admin/sponsors/detail/:id",
    element: DetailSponsor,
    parent: "ListSponsors",
  },
  UpdateSponsorUser: {
    icon: "User",
    name: "Atualizar Usuário Patrocinador",
    path: "/admin/sponsors/update-user/:id",
    element: UpdateSponsorUser,
    parent: "ListSponsors",
  },
  ListParticipants: {
    icon: "User",
    name: "Listar Proponentes",
    path: "/admin/participants/list",
    element: ListParticipants,
  },
  CreateParticipant: {
    icon: "User",
    name: "Criar Proponente",
    path: "/admin/participants/create",
    element: CreateParticipant,
  },
  DetailParticipant: {
    icon: "User",
    name: "Detalhe do Proponente",
    path: "/admin/participants/detail/:id",
    element: DetailParticipant,
    parent: "ListParticipants",
  },
  UpdateParticipantUser: {
    icon: "User",
    name: "Atualizar Usuário Proponente",
    path: "/admin/participants/update-user/:id",
    element: UpdateParticipantUser,
    parent: "ListParticipants",
  },
  ListSeletivas: {
    icon: "List",
    name: "Listar Seletivas",
    path: "/admin/seletivas/list",
    element: ListSeletivas,
  },
  CreateSeletiva: {
    icon: "List",
    name: "Criar Seletiva",
    path: "/admin/seletivas/create",
    element: CreateSeletiva,
  },
  UpdateSeletiva: {
    icon: "List",
    name: "Editar Seletiva",
    path: "/admin/seletivas/update/:id",
    element: UpdateSeletiva,
    parent: "ListSeletivas",
  },
  ListProductions: {
    icon: "News",
    name: "Listar Produções",
    path: "/admin/productions/list",
    element: ListProductions,
  },
  CreateProductions: {
    icon: "News",
    name: "Criar Produção",
    path: "/admin/productions/create",
    element: CreateProductions,
  },
  UpdateProductions: {
    icon: "News",
    name: "Atualizar Produção",
    path: "/admin/productions/update/:id",
    element: UpdateProductions,
    parent: "ListProductions",
  },
  ListProjects: {
    icon: "Display",
    name: "Listar Projetos",
    path: "/admin/projects/list",
    element: ListProjects,
  },
  UpdateProjects: {
    icon: "Display",
    name: "Atualizar Projeto",
    path: "/admin/projects/update/:id",
    element: UpdateProjects,
    parent: "ListProjects",
  },
  PendingApprovals: {
    icon: "Display",
    name: "Pendências",
    path: "/admin/pendencias",
    element: PendingApprovals,
  },
  ListNotifications: {
    icon: "Bell",
    name: "Listar Notificações",
    path: "/admin/notifications/list",
    element: ListNotifications,
  },
  CreateNotification: {
    icon: "Bell",
    name: "Criar Notificação",
    path: "/admin/notifications/create",
    element: CreateNotification,
  },
  CreateNotificationType: {
    icon: "Bell",
    name: "Criar Categoria de Notificação",
    path: "/admin/notifications/create-type",
    element: CreateNotificationType,
  },
  NotificationDetails: {
    icon: "Bell",
    name: "Detalhes da Notificação",
    path: "/admin/notifications/details/:id",
    element: ManageNotification,
    parent: "ListNotifications",
  },
  Configurations: {
    icon: "Settings",
    name: "Configurações",
    path: "/admin/configurations",
    element: Configurations,
  },
  NotificationCenter: {
    icon: "Bell",
    name: "Central de notificações",
    path: "/admin/notification-center",
    element: NotificationCenter,
  },
};

export default AdminRoutes;
